// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"ImageSlider_slideshow__1BwDW","slideshowSlider":"ImageSlider_slideshowSlider__gqAMc","slide":"ImageSlider_slide__mbbDn"};